/**
 * 商家后台 JSON API 的同源路径常量。
 * apps/shopify 的 api.* 路由与 apps/admin 的请求函数都从这里取路径，两边不各写字符串。
 */
export const paths = {
  storeConnection: "/api/store-connection",
  homeMetrics: "/api/home/metrics",
  inboxConversations: "/api/inbox/conversations",
  inboxConversationMessages: (conversationId: string) =>
    `/api/inbox/conversations/${encodeURIComponent(conversationId)}/messages`,
  feedbackReasons: "/api/feedback/reasons",
  feedbackMessages: "/api/feedback/messages",
  feedbackMessage: (messageId: string) =>
    `/api/feedback/messages/${encodeURIComponent(messageId)}`,
  knowledgeOverview: "/api/knowledge/overview",
  knowledgeProducts: "/api/knowledge/products",
  knowledgeQuestions: "/api/knowledge/questions",
  playgroundSessions: "/api/playground/sessions",
  settings: "/api/settings",
  settingsSupportEmail: "/api/settings/support-email",
  settingsLogo: "/api/settings/logo",
  settingsPickerToken: "/api/settings/picker-token",
} as const;
